export default function formatMessageContentEventChatNotice ({ kh }) {
    return {
        text: kh
    }
}
